let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7OLfM")).then(() => parcelRequire('8ZbKQ'));